export default {
      id: "help-center-api-usage",
      viewBox: "0 0 20 21",
      url: __webpack_public_path__ + "icons.svg#help-center-api",
      toString: function () {
        return this.url;
      }
    }